import { Badge } from "@/components/ui/badge";
import { CampaignType } from "@/@types/campaign";
import { Lock, Percent, Package, Layers } from "lucide-react";

interface CampaignTypeBadgeProps {
  type: CampaignType;
  showIcon?: boolean;
}

export function CampaignTypeBadge({ type, showIcon = true }: CampaignTypeBadgeProps) {
  const config = {
    [CampaignType.PRO012]: {
      label: "Combo Legado",
      variant: "secondary" as const,
      icon: Lock,
      className: "bg-gray-100 text-gray-700 border-gray-300",
    },
    [CampaignType.PRO013]: {
      label: "Leve X Pague Y",
      variant: "default" as const,
      icon: Percent,
      className: "bg-purple-100 text-purple-700 border-purple-300",
    },
    [CampaignType.PRO014]: {
      label: "Promoção Itens",
      variant: "default" as const,
      icon: Package,
      className: "bg-blue-100 text-blue-700 border-blue-300",
    },
    [CampaignType.PRO017]: {
      label: "Combo Moderno",
      variant: "default" as const,
      icon: Layers,
      className: "bg-green-100 text-green-700 border-green-300",
    },
  };

  const { label, icon: Icon, className } = config[type] || config[CampaignType.PRO013];

  return (
    <Badge variant="outline" className={`${className} font-medium`}>
      {showIcon && <Icon className="w-3 h-3 mr-1" />}
      {label}
    </Badge>
  );
}
